export enum AgTechFormState {
    Open,
    Submitting,
    Successful,
    Failed
}